export const fileTypes = {
    json: 'application/json',
    csv: 'text/csv',
    gif: 'image/gif',
    jpg: 'image/jpeg',
    png: 'image/png',
    svg: 'image/svg+xml',
};
//# sourceMappingURL=data.js.map